import styled from 'styled-components';

import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const Wrapper = styled.div`
    flex-direction: column;
    margin-top: 4px;
`;

export const Info = styled.div`
    white-space: pre-wrap;
`;

export const Text = styled.p`
    ${FONTS.S};
    color: ${COLORS.TextSecondary};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS};
    }
`;

export const Balance = styled.p`
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
    margin-top: 4px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS};
    }
`;

export const SetupButton = styled(BaseButton)`
    margin: 16px 0;
`;

export const Agreement = styled(Balance)`
    ${FONTS.XS};
`;
